import axios, { AxiosError } from 'axios';
import { getAuthToken, removeAuthToken } from './auth';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://lavernaibackend.onrender.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Only handle 401 errors, ignore other errors to prevent unnecessary logouts
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      
      // Check if we're on any protected route (including competitor routes)
      const isProtectedRoute = currentPath.includes('/auth/') || 
                              currentPath.includes('/dashboard') || 
                              currentPath.includes('/app/') ||
                              currentPath.includes('/competition') ||
                              currentPath.includes('/content-creator') ||
                              currentPath.includes('/teacher') ||
                              currentPath.includes('/admin');
      
      // Only clear auth token if we're not on any protected route
      if (!isProtectedRoute) {
        console.log('API 401 on non-protected route, clearing auth token');
        removeAuthToken();
        // Only redirect if we're not in a protected route
        window.location.href = '/auth/login';
      } else {
        console.log('API 401 on protected route, keeping session active:', currentPath);
        // Don't clear token on protected routes - let the component handle it
      }
    }
    return Promise.reject(error);
  }
); 